// extracted by mini-css-extract-plugin
module.exports = {"sn-avatar-group":"avatar_sn-avatar-group__3EzpR","sn-avatar":"avatar_sn-avatar__2Zja9","search-dialog-result-body":"avatar_search-dialog-result-body__1Ow4c"};